module.exports = ".full-width {\n  width: 100%; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/consulta/alergias/alergiasdetalle/alergiasdetalle.component.scss
// module id = ./src/app/consulta/alergias/alergiasdetalle/alergiasdetalle.component.scss
// module chunks = main